import { WITH_RX, WITHOUT_RX } from "./contants.js";
const isRxRadioSelection = (value) => value === WITH_RX || value === WITHOUT_RX;
const isWithoutRx = (value) => value === WITHOUT_RX;
const isWithRx = (value) => value === WITH_RX;
export {
  isRxRadioSelection,
  isWithRx,
  isWithoutRx
};
//# sourceMappingURL=is-rx-radio-selection.js.map
